
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Priority } from "@/types/habit";

interface PrioritySelectorProps {
  priority: Priority;
  onChange: (value: Priority) => void;
}

export const PrioritySelector = ({ priority, onChange }: PrioritySelectorProps) => {
  return (
    <div className="space-y-2">
      <Label>Priority Level</Label>
      <RadioGroup 
        value={priority} 
        onValueChange={(value: Priority) => onChange(value)}
        className="flex space-x-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="high" id="high" />
          <Label htmlFor="high">High</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="medium" id="medium" />
          <Label htmlFor="medium">Medium</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="low" id="low" />
          <Label htmlFor="low">Low</Label>
        </div>
      </RadioGroup>
    </div>
  );
};
